import "../styles/work.css";
import Vedio from "./Vedio";
import { client } from "../api/Client";
import { useState, useEffect } from "react";
export default function Work() {
  let [vedioData, setVedio] = useState();
  let [loadData, setLoadData] = useState(false);

  useEffect(() => {
    if(loadData === false) {
      client.get("/GetVedios/6")
      .then((res) => {
        setVedio(res.data.Vedios)
        console.log(res.data.Vedios)
      })
      .catch(error => {
        alert(error)
      })
      setLoadData(true)
    }
  },[])
  return (
    <>
      <section className="Works">
        <div className="container-works">
          <h2 id="works">Works</h2>
          <div className="container-vedios">
            {
              vedioData?.map(item => {
                return ( 
                  <>
                    <Vedio linkVedio={ item.VedioURL } /> 
                  </>
                );
              })
            }
          </div>
        </div>
      </section>
    </>
  );
};